import React, { useEffect } from 'react';
import { useChatbotContext } from '../context/ChatbotContext';

// This component reads the slug from page props and updates the context
const PageSlugUpdater = ({ element, props }) => {
  const { setCommunitySlug } = useChatbotContext();
  const currentSlug = props?.pageContext?.slug;

  useEffect(() => {
    // Update the context whenever the slug from pageContext changes
    setCommunitySlug(currentSlug);
  }, [currentSlug, setCommunitySlug]);

  // Return the original page element unchanged
  return element;
};

export default PageSlugUpdater; 